/** Storage can be disabled by browser policy, especially in third-party frames. */
export function readStoredValue(key: string): string | null {
  try { return window.localStorage.getItem(key); } catch { return null; }
}
export function writeStoredValue(key: string, value: string): boolean {
  try { window.localStorage.setItem(key, value); return true; } catch { return false; }
}
export interface SavedGradeScale { letter: string; min: number; max: number }
export function parseGradeScale(raw: string | null): SavedGradeScale[] | null {
  if (!raw || raw.length > 20000) return null;
  try {
    const value: unknown = JSON.parse(raw);
    if (!Array.isArray(value) || value.length === 0 || value.length > 100) return null;
    if (!value.every(entry => entry && typeof entry === 'object'
      && typeof entry.letter === 'string' && entry.letter.trim().length > 0 && entry.letter.length <= 20
      && typeof entry.min === 'number' && Number.isFinite(entry.min)
      && typeof entry.max === 'number' && Number.isFinite(entry.max)
      && entry.min >= 0 && entry.max <= 100 && entry.min <= entry.max)) return null;
    return value.map(({ letter, min, max }) => ({ letter, min, max }));
  } catch { return null; }
}
